import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, " Batch Wise Enrollment Summary ")
  ])
], -1)
const _hoisted_3 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-9" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tranche", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Partner", -1)
const _hoisted_13 = { class: "col-md-2 mt-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_15 = { class: "position-relative mt-7" }
const _hoisted_16 = {
  style: {"float":"right"},
  class: "col-md-6 text-end",
  "data-v-54b12dc8": ""
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-excel fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-pdf fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa fa-print fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" })
], -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" })
], -1)
const _hoisted_25 = { class: "table table-borderless gy-4" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-dark" }, [
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid #50cd89 !important","text-align":"center"},
      rowspan: "2"
    }, " Sl "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid #50cd89 !important","text-align":"center"},
      rowspan: "2"
    }, " Training Partner "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid #50cd89 !important","text-align":"center"},
      rowspan: "2"
    }, " Training Institute "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid #50cd89 !important","text-align":"center"},
      rowspan: "2"
    }, " Courses "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid #50cd89 !important","text-align":"center"},
      rowspan: "2"
    }, " Batches "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid #50cd89 !important","text-align":"center"},
      colspan: "2",
      class: "border border-grey text-center"
    }, " Enrollment "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid #50cd89 !important","text-align":"center"},
      colspan: "2",
      class: "border border-grey text-center"
    }, " Assesment "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid #50cd89 !important","text-align":"center"},
      colspan: "2",
      class: "border border-grey text-center"
    }, " Certification "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid #50cd89 !important","text-align":"center"},
      colspan: "2",
      class: "border border-grey text-center"
    }, " Job Placement ")
  ]),
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-dark" }, [
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }, " Total "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }, " Female "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }, " Total "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }, " Female "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }, " Total "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }, " Female "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }, " Total "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }, " Female ")
  ])
], -1)
const _hoisted_27 = { style: {} }
const _hoisted_28 = { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-dark" }
const _hoisted_29 = {
  colspan: "13",
  style: {"border":"1px solid #50cd89 !important"}
}
const _hoisted_30 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_31 = { style: {"border":"1px solid #50cd89 !important","text-align":"left"} }
const _hoisted_32 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_33 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_34 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_35 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_36 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_37 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_38 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_39 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_40 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_41 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_42 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_43 = {
  colspan: "2",
  style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"}
}
const _hoisted_44 = /*#__PURE__*/_createElementVNode("td", { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }, null, -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("td", { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }, null, -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("td", { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }, null, -1)
const _hoisted_47 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_48 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_49 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_50 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_51 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_52 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_53 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_54 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "2",
  style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"}
}, " Total ", -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("td", { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }, null, -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("td", { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }, null, -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("td", { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }, null, -1)
const _hoisted_59 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_60 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_61 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_62 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_63 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_64 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_65 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_66 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Form = _resolveComponent("Form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_Form, {
    onSubmit: _cache[6] || (_cache[6] = ($event: any) => (_ctx.formSubmit())),
    class: "form",
    "validation-schema": _ctx.AssociationSchema
  }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _hoisted_10,
                    _createVNode(_component_Multiselect, {
                      modelValue: _ctx.tranche_id,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tranche_id) = $event)),
                      options: _ctx.optionsTranche,
                      mode: "tags",
                      "clear-on-select": false,
                      placeholder: "Select Tranche",
                      "close-on-select": false,
                      searchable: true,
                      "create-option": true
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _createVNode(_component_Multiselect, {
                      modelValue: _ctx.entity_id,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.entity_id) = $event)),
                      options: _ctx.optionsTPartner,
                      mode: "tags",
                      "clear-on-select": false,
                      placeholder: "Select Training Partner",
                      "close-on-select": false,
                      searchable: true,
                      "create-option": true
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("button", {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.trainingProviderNotice())),
                      type: "button",
                      class: "btn btn-success mt-6 p-3",
                      style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                    }, [
                      _createTextVNode(" Search "),
                      _hoisted_14
                    ])
                  ])
                ]),
                (_ctx.showCourseNotice == true)
                  ? (_openBlock(), _createElementBlock("div", { key: _ctx.componentKey }, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-success btn-lg btn-icon fs-7 p-4",
                            title: "Download Xlse",
                            "data-v-54b12dc8": "",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.exportTrainee()))
                          }, _hoisted_18),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-danger btn-lg btn-icon fs-7 ml-3 p-4",
                            title: "Download PDF",
                            "data-v-54b12dc8": "",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.downloadPdf()))
                          }, _hoisted_20),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-dark btn-lg btn-icon fs-7 ml-3 p-4",
                            title: "Print",
                            "data-v-54b12dc8": "",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.printPdf()))
                          }, _hoisted_22),
                          _hoisted_23,
                          _hoisted_24
                        ]),
                        _createElementVNode("table", _hoisted_25, [
                          _hoisted_26,
                          _createElementVNode("tbody", _hoisted_27, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.batchSummaryReport, (info, key) => {
                              return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                                _createElementVNode("tr", _hoisted_28, [
                                  _createElementVNode("td", _hoisted_29, [
                                    _createElementVNode("b", null, _toDisplayString(info?.trancheInfo?.label), 1)
                                  ])
                                ]),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info?.trancheInfo
                          ?.batch_summary, (data, inx) => {
                                  return (_openBlock(), _createElementBlock("tr", { key: inx }, [
                                    _createElementVNode("td", _hoisted_30, _toDisplayString(inx + 1), 1),
                                    _createElementVNode("td", _hoisted_31, _toDisplayString(data?.entity_info?.entity_short_name), 1),
                                    _createElementVNode("td", _hoisted_32, _toDisplayString(data?.institute_info?.institute_name), 1),
                                    _createElementVNode("td", _hoisted_33, _toDisplayString(data?.course_info?.course_name), 1),
                                    _createElementVNode("td", _hoisted_34, _toDisplayString(data?.batch_info?.batch_number), 1),
                                    _createElementVNode("td", _hoisted_35, _toDisplayString(data?.t_enrolled), 1),
                                    _createElementVNode("td", _hoisted_36, _toDisplayString(data?.f_enrolled), 1),
                                    _createElementVNode("td", _hoisted_37, _toDisplayString(data?.t_assessed), 1),
                                    _createElementVNode("td", _hoisted_38, _toDisplayString(data?.f_assessed), 1),
                                    _createElementVNode("td", _hoisted_39, _toDisplayString(data?.t_certified), 1),
                                    _createElementVNode("td", _hoisted_40, _toDisplayString(data?.f_certified), 1),
                                    _createElementVNode("td", _hoisted_41, _toDisplayString(data?.t_employed), 1),
                                    _createElementVNode("td", _hoisted_42, _toDisplayString(data?.f_employed), 1)
                                  ]))
                                }), 128)),
                                _createElementVNode("tr", null, [
                                  _createElementVNode("td", _hoisted_43, " Subtotal(" + _toDisplayString(info?.trancheInfo?.label) + ") ", 1),
                                  _hoisted_44,
                                  _hoisted_45,
                                  _hoisted_46,
                                  _createElementVNode("td", _hoisted_47, _toDisplayString(_ctx.numberWithCommas(
                                info?.trancheInfo?.subTotalenrollment
                              )), 1),
                                  _createElementVNode("td", _hoisted_48, _toDisplayString(_ctx.numberWithCommas(
                                info?.trancheInfo?.subTotalenrollment_female
                              )), 1),
                                  _createElementVNode("td", _hoisted_49, _toDisplayString(_ctx.numberWithCommas(
                                    info?.trancheInfo?.subtotal_assesment
                                  )), 1),
                                  _createElementVNode("td", _hoisted_50, _toDisplayString(_ctx.numberWithCommas(
                                    info?.trancheInfo?.subtotal_assesment_female
                                  )), 1),
                                  _createElementVNode("td", _hoisted_51, _toDisplayString(_ctx.numberWithCommas(
                                info?.trancheInfo?.subTotalcertification
                              )), 1),
                                  _createElementVNode("td", _hoisted_52, _toDisplayString(_ctx.numberWithCommas(
                                info?.trancheInfo?.subTotalcertification_female
                              )), 1),
                                  _createElementVNode("td", _hoisted_53, _toDisplayString(_ctx.numberWithCommas(
                                info?.trancheInfo?.subtotal_job_placement
                              )), 1),
                                  _createElementVNode("td", _hoisted_54, _toDisplayString(_ctx.numberWithCommas(
                                info?.trancheInfo?.subtotal_job_placement_female
                              )), 1)
                                ])
                              ], 64))
                            }), 128)),
                            _createElementVNode("tr", null, [
                              _hoisted_55,
                              _hoisted_56,
                              _hoisted_57,
                              _hoisted_58,
                              _createElementVNode("td", _hoisted_59, _toDisplayString(_ctx.numberWithCommas(this.Totalenrollment)), 1),
                              _createElementVNode("td", _hoisted_60, _toDisplayString(_ctx.numberWithCommas(this.Totalenrollment_female)), 1),
                              _createElementVNode("td", _hoisted_61, _toDisplayString(_ctx.numberWithCommas(this.Totalassesment)), 1),
                              _createElementVNode("td", _hoisted_62, _toDisplayString(_ctx.numberWithCommas(this.Totalassesment_female)), 1),
                              _createElementVNode("td", _hoisted_63, _toDisplayString(_ctx.numberWithCommas(this.Totalcertification)), 1),
                              _createElementVNode("td", _hoisted_64, _toDisplayString(_ctx.numberWithCommas(this.Totalcertification_female)), 1),
                              _createElementVNode("td", _hoisted_65, _toDisplayString(_ctx.numberWithCommas(this.Totaljobplacement)), 1),
                              _createElementVNode("td", _hoisted_66, _toDisplayString(_ctx.numberWithCommas(this.Totaljobplacement_female)), 1)
                            ])
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ])), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _: 1
  }, 8, ["validation-schema"]))
}